import {
  CatalogGovernanceValue,
  formatGovernanceValue,
} from '@/types/catalogGovernance'
import { twMerge } from 'tailwind-merge'

interface CatalogStatusBadgeProps {
  label: string
  value?: CatalogGovernanceValue | null
  className?: string
}

const statusClassMap: Record<CatalogGovernanceValue, string> = {
  DRAFT: 'border-amber-200 bg-amber-50 text-amber-700',
  PUBLISHED: 'border-green-200 bg-green-50 text-green-700',
  HIDDEN: 'border-slate-200 bg-slate-100 text-slate-700',
  UNCLAIMED: 'border-slate-200 bg-slate-100 text-slate-700',
  CLAIM_PENDING: 'border-orange-200 bg-orange-50 text-orange-700',
  VERIFIED: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  NONE: 'border-slate-200 bg-slate-100 text-slate-700',
  PENDING_REVIEW: 'border-yellow-200 bg-yellow-50 text-yellow-700',
  REJECTED: 'border-red-200 bg-red-50 text-red-700',
  DISABLED: 'border-slate-200 bg-slate-100 text-slate-700',
  INTERNAL_ONLY: 'border-blue-200 bg-blue-50 text-blue-700',
  ENABLED: 'border-green-200 bg-green-50 text-green-700',
}

export function CatalogStatusBadge({
  label,
  value,
  className,
}: CatalogStatusBadgeProps) {
  const statusClass = value
    ? statusClassMap[value]
    : 'border-slate-200 bg-slate-100 text-slate-500'

  return (
    <span
      className={twMerge(
        'inline-flex items-center rounded-full border px-2 py-1 text-xs font-semibold',
        statusClass,
        className,
      )}
      title={`${label}: ${formatGovernanceValue(value)}`}
    >
      {label}: {formatGovernanceValue(value)}
    </span>
  )
}
